module.exports = __webpack_public_path__ + "static/media/res14.f10a6686.PNG";